<app-insights-header mrt-insights-header [mobileFilterBreakpointReached]='mobileFilterBreakpointReached'
  [followBreakpointReached]='followBreakpointReached' [isFollowing]='isFollowing' [processingFollow]='isProcessing'
  (mobileNavOpenClick)='showMobileNav = !showMobileNav' (followButtonClick)='handleFollowClick($event)'
  (applyFilter)="applyFilter()" (resetFilter)="resetFilter()" (showFilter)="showFilter()">
  <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups" mrt-insights-filters>
    <ng-container *ngIf="!isFreemium">
      <ng-container *ngIf="desktop$ | async">
        <ng-container *ngFor="let mainFilterItem of mainFilterItems">
          <div class="dropdown filter-dropdown ml-2" [ngClass]="{ disabled: mainFilterItem?.disabled }"
            (click)="dropdownClick($event, mainFilterItem,'search-input-' + mainFilterItem?.key)">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              [ngClass]="{ highlighted : mainFilterItem?.highlighted, disabled: mainFilterItem?.disabled }"
              [innerHTML]="mainFilterItem?.selected?.label">
            </button>
            <div class="filter-dropdown-tooltip"
              *ngIf="mainFilterItem?.showTooltip && mainFilterItem?.tooltip?.length > 0">
              {{mainFilterItem?.tooltip}}
              <i class="fa fa-caret-down"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <ng-container *ngIf="mainFilterItem?.options?.length > 10">
                <div class="input-group">
                  <span class="input-group-addon" id="search-country">
                    <i class="fa fa-search"></i>
                  </span>
                  <input type="text" class="form-control" placeholder="Search..."
                    [attr.id]="'search-input-' + mainFilterItem?.key"
                    [attr.aria-describedby]="'search-country-'+mainFilterItem?.key"
                    (keydown.enter)="searchMainFilterItemOption(mainFilterItem, $event)">
                </div>
              </ng-container>
              <div class="dropdown-menu-items">
                <ng-container *ngFor="let option of mainFilterItem?.options">
                  <a class="dropdown-item" (click)="selectMainFilter(mainFilterItem,option)" [innerHTML]="option?.label"
                    [hidden]="option?.hidden">
                  </a>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="tablet$ | async">
        <ng-container *ngFor="let mainFilterItem of mainFilterItems">
          <div class="mobile-filter dropdown filter-dropdown ml-2" [ngClass]="{ disabled: mainFilterItem?.disabled }">
            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton2"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              [ngClass]="{ disabled: mainFilterItem?.disabled }" (click)="toggleDropdownOption(mainFilterItem, true)">
              {{mainFilterItem?.selected?.label}}
            </button>
            <hr />
            <div class="options-overlay" [ngClass]="{'show': mainFilterItem.show}" aria-labelledby="dropdownMenuButton"
              (click)="toggleDropdownOption(mainFilterItem, false)">
              <div class="options-container">
                <span class="h5 m-3 text-capitalize">{{ mainFilterItem.key }}</span>
                <hr />
                <ng-container *ngFor="let option of mainFilterItem?.options">
                  <div class="d-flex flex-row justify-content-between m-3">
                    <a (click)="selectMainFilter(mainFilterItem,option,false)">
                      {{option.label}}
                    </a>
                    <i *ngIf="option.value == mainFilterItem.selected.value" class='fa fa-check'></i>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

    </ng-container>
  </div>
  <div class='text-right' mrt-insights-filters>
    <div class="last-update-date mb-2" [ngClass]="{ 'invisible' : loading }"
      *ngIf="(!isFreemium || (isFreemium && isFollowing))">
      Last Update as of {{insightsData?.overview?.lastUpdatedDateString}}
    </div>
    <app-changelog-btn (showChangelog)="showChangelog()">
    </app-changelog-btn>
  </div>
  <div mrt-insights-icon>
    <ng-container *ngIf="insightsData?.overview?.adDomain">
      <img class="app-details-logo"
        src="https://www.google.com/s2/favicons?domain={{insightsData?.overview?.adDomain}}&sz=48"
        alt="Domain Details Logo" />
    </ng-container>
  </div>

  <div mrt-insights-apptitle class="overflow-hidden text-overflow-ellipsis">
    <ng-container *ngIf="insightsData?.overview?.adDomain">
      {{insightsData?.overview?.adDomain}}
    </ng-container>
  </div>
</app-insights-header>

<div class="insight-details-main-content">
  <app-side-navigation navTitle='Domain Insights' [availableSections]='sideNavItems'
    [enabledSectionIds]='enabledSectionIds$ | async' [activeSection]='activeSection' [isFollowing]='isFollowing'
    [showMobile]='showMobileNav' (showChangelogClick)='showChangelog()' (navItemClick)='handleSideNavClick( $event )'
    (navCloseClick)='showMobileNav = false'>
  </app-side-navigation>

  <main class="right-content insight-details app-details p-0" *ngIf="desktop$ | async">
    <div class="container-fluid main-content p-0" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
      <div class="body-content" id="body-content">
        <div class='claim-container'>
          <div class='claim-app' (click)='gotoClaimForm()' aria-role='button'>
            Get Publisher Diagnostic Report
          </div>
        </div>
        <div class="p-4" *ngIf="loading || loadingData">
          Loading data
          <i class="fa fa-spin fa-spinner ml-2"></i>
        </div>
        <ng-container *ngIf="insightsData && !loadingData && !showNoData">
          <ng-container *ngFor="let navItem of sideNavItems">
            <div class="row mb-4 detail-section"
              *ngIf="insightsData | showIf : navItem?.showIf : device: mainFilterItems" [attr.id]="navItem.key"
              mrt-insights-section>
              <div class="col-lg-12">
                <app-insights-section-container [appName]="getAppName()" [appId]="appId" [data]="insightsData"
                  [device]="device" [region]="region" [month]="month" [isFreemium]="isFreemium"
                  [isAnonymous]="isAnonymous" [selectedCountry]="selectedCountry"
                  [widgetComponent]="navItem?.widgetComponent" (toAppDiscovery)="toAppDiscoveryClick($event)"
                  (followButtonBreakpointReached)='followBreakpointReached = $event'
                  (followButtonClick)='handleFollowClick($event)' (anchorClick)="goToSection($event)">
                </app-insights-section-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
      </div>
    </div>
  </main>

  <main class="w-100 mobile-main" *ngIf="tablet$ | async">
    <ng-container *ngIf="loading || loadingData">
      <div style="margin-top: 25vh; margin-left: calc(50vw - 70px);">
        <i class="fa fa-spinner fa-spin mr-2"></i> Loading data...
      </div>
    </ng-container>
    <ng-container *ngIf="insightsData && !loadingData && !showNoData">
      <div class="container-fluid px-0">
        <div class="row">
          <div class="col">
            <ng-template #swipercontrols>
              <div class="swiper-controls" *ngIf="swiper?.swiperRef">
                <button class="btn btn-link p-0 mr-2" [ngClass]="{ disabled: swiper.swiperRef.isBeginning }"
                  (click)="swiper.swiperRef.slidePrev(300)">
                  <img src="assets/images/arrow-left.svg" />
                </button>
                <button class="btn btn-link p-0" [ngClass]="{ disabled: swiper.swiperRef.isEnd }"
                  (click)="swiper.swiperRef.slideNext(300)">
                  <img src="assets/images/arrow-right.svg" />
                </button>
              </div>
            </ng-template>
            <swiper #swiper [autoHeight]="true" [slidesPerView]="1" [spaceBetween]="0"
              wrapperClass="swiper-wrapper min-h-100vh" (slideChange)="onSlideChange($event)">
              <ng-container *ngFor="let navItem of sideNavItems; first as isFirst; index as index;">
                <ng-container *ngIf="insightsData">
                  <ng-template swiperSlide let-data>
                    <div [attr.id]="navItem.key" mrt-insights-section>
                      <ng-container *ngIf="data?.isActive || data?.isPrev || data?.isNext">
                        <app-insights-section-container class="w-100" [appName]="getAppName()" [appId]="appId"
                          [data]="insightsData" [device]="device" [region]="region" [month]="month"
                          [isAnonymous]="isAnonymous" [selectedCountry]="selectedCountry"
                          [widgetComponent]="navItem?.widgetComponent" (toAppDiscovery)="toAppDiscoveryClick($event)"
                          [swiperControls]="swipercontrols"
                          (followButtonBreakpointReached)='followBreakpointReached = $event'
                          (followButtonClick)='handleFollowClick($event)' (anchorClick)="goToSection($event)">
                        </app-insights-section-container>
                      </ng-container>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
            </swiper>

          </div>
        </div>
      </div>
    </ng-container>
    <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
  </main>
</div>

<ng-container>
  <div class="modal fade" id="changelogModal" tabindex="-1" role="dialog" aria-labelledby="changelogModalLabel"
    aria-hidden="true" #changelogModal>
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title w-100">
            <h6 class="mb-3 d-sm-none">Changelog</h6>
            <div class="d-flex flex-row">
              <img class="appIcon"
                attr.src="https://www.google.com/s2/favicons?domain={{insightsData?.overview?.adDomain}}&sz=48"
                alt="{{ insightsData?.overview?.adDomain }} Favicon" />
              <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mr-sm-5 w-100">
                <h5 class="d-inline">{{insightsData?.overview?.adDomain}}</h5>
                <div class="d-inline">
                  <button [disabled]="isProcessing" class="btn btn-primary d-flex flex-nowrap"
                    [class.btn-follow]="!isFollowing" [class.btn-unfollow]="isFollowing"
                    (click)="isFollowing ? unfollowApp() : followApp()">
                    <ng-container *ngIf="!isFreemium">
                      <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
                      <i class="fa fa-plus mr-1" *ngIf="!isFollowing"></i>
                    </ng-container>
                    <ng-container *ngIf="isFreemium">
                      <i class="fa fa-lock mr-1" *ngIf="!isFollowing"></i>
                      <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
                    </ng-container>
                    {{ isFollowing ? "Following" : "Follow" }}
                    <ng-container *ngIf="isFreemium && !isFollowing">
                      to show all changes
                    </ng-container>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-app-changelog [changeLogData]="changeLogData" [region]="region" [isFollowing]="isFollowing"
            [isFreemium]="isFreemium"></app-app-changelog>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noDataFoundTemplate>
  <div class="no-data-container" *ngIf="showNoData">
    <div class="alert alert-warning" role="alert">
      <strong>Not found.</strong> Sorry no <span *ngIf="month">{{monthFilter?.selected?.label}}</span>
      {{region}} information was found for {{appId}}
      on {{device}}.
    </div>
    <div class="alert alert-warning available-filters" role="alert" *ngIf="availableFilters?.length > 0">
      Try other available searches ?
      <ul>
        <li *ngFor="let domainFilter of availableFilters">
          <a class="btn btn-link" (click)="availableFilterClick(domainFilter)">
            {{domainFilter.regionText}} for the {{domainFilter.domain}} on {{domainFilter.device}}
            in {{domainFilter?.monthLabel}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>